import { AbstractOperationMessage } from "./abstractOperationMessage"

export class ChangeOwnershipMessage extends AbstractOperationMessage {

}